/** Session Types */
export const CREATE_SESSION = 'CREATE_SESSION';
export const GET_SESSIONS = 'GET_SESSIONS';
export const GET_SESSIONS_SUCCESS = 'GET_SESSIONS_SUCCESS';
export const GET_SESSION_BY_ID = 'GET_SESSION_BY_ID';
export const GET_SESSION_BY_ID_SUCCESS = 'GET_SESSION_BY_ID_SUCCESS';

export const RESUME_SESSION = 'RESUME_SESSION';
export const PAUSE_SESSION = 'PAUSE_SESSION';
export const END_SESSION = 'END_SESSION';

export const SAVE_SESSION_TARGET_OPTION = 'SAVE_SESSION_TARGET_OPTION';
export const SAVE_SESSION_TARGET_OPTION_SUCCESS = 'SAVE_SESSION_TARGET_OPTION_SUCCESS';
export const DELETE_TRIAL_LOG = 'DELETE_TRIAL_LOG';
export const REFRESH_SESSION = 'REFRESH_SESSION';
export const EDIT_SESSION_GOALS = 'EDIT_SESSION_GOALS';

export const EDIT_SESSION_TIMELINE = 'EDIT_SESSION_TIMELINE';
export const GET_SESSION_CORRECTIONS = 'GET_SESSION_CORRECTIONS';
export const GET_SESSION_CORRECTIONS_SUCCESS = 'GET_SESSION_CORRECTIONS_SUCCESS';

/** Manual session data entry (Client → Goals → Add Data) */
export const GET_MANUAL_SESSION_APPTS = 'GET_MANUAL_SESSION_APPTS';
export const GET_MANUAL_SESSION_APPTS_SUCCESS = 'GET_MANUAL_SESSION_APPTS_SUCCESS';
export const GET_MANUAL_SESSION = 'GET_MANUAL_SESSION';
export const GET_MANUAL_SESSION_SUCCESS = 'GET_MANUAL_SESSION_SUCCESS';
export const SAVE_MANUAL_SESSION = 'SAVE_MANUAL_SESSION';
export const RESET_MANUAL_SESSION = 'RESET_MANUAL_SESSION';
export const GET_MANUAL_MAINTENANCE_CHECKS = 'GET_MANUAL_MAINTENANCE_CHECKS';
export const GET_MANUAL_MAINTENANCE_CHECKS_SUCCESS = 'GET_MANUAL_MAINTENANCE_CHECKS_SUCCESS';

/** End */
